export default {
  en: {
    titles: {
      customization: "1. Turret Type",
      scope: "2. Scope",
      ammunition: "3. Ammunition",
      firearm: "4. Firearm",
      environment: "5. Environment"
    },
    generic: {
      step: "Step: ",
      custom: "Custom",
      other: "Other",
      grains: "grains",
      fahrenheit: "Fahrenheit",
      celsius: "Celsius",
      yards: "yards",
      meters: "meters",
      inches: "inches",
      centimeters: "centimeters",
      pleaseNote: "Please Note",
      submit: "Submit",
      submitting: "Submitting...",
      turret: "Custom Turret",
      turretPreviewTitle: "Turret Preview:",
      turretPreview: "Your turret preview will update here as you make adjustments above.",
      price: "Total: ",
      subtotal: "Subtotal: ",
      feedback: "If you ever have any questions or feedback, please feel free to contact us."
    },
    turretCustomizer: {
      couponNotice: "If you have a coupon code you will be able to enter it during checkout.",
      readyToOrder: "Ready To Order?",
      addToCart: "Add To Cart",
      checkoutNow: "Checkout Now",
      labelNotesText: "What Is This",
      labelNotes: "Your Turret previews begin at the zero (0) indicator and continues onto the opposite side. If any numbers overlap on your turret preview they will be corrected by our team before printing or laser engraving.",
      tabs: {
        scope: "Scope",
        ammunition: "Ammunition",
        firearm: "Firearm",
        environment: "Environment",
        customization: "Turret Type"
      },
      customizationType: {
        formHint: "Please note that for some scopes we offer only our Weatherproof Label option. If you have any questions you can reach us at <a href='mailto:support@ballistix.ca'>support@ballistix.ca</a>.",
        customFormHint: "Thank you for your interest in our Custom Turrets. Please select a turret type from the options above.",
        burnedTurret: "Laser Engraved Turret",
        turretDescription: "A custom laser engraved turret, perfectly tailored for your scope, rifle and shooting environment.",
        turretSticker: "Weatherproof Turret Label (3)",
        stickerDescription: "Custom stick-on label perfectly sized to fit on your existing turret. You'll receive 3 copies of your turret label."
      },
      confirmation: {
        title: "Please Create An Account",
        body: "Before you can checkout or add to cart, you'll need to create an account. Don't worry, your turret customization will be saved. Click \"okay\" to proceed or \"cancel\" to go back to the turret customizer."
      },
      notes: "Notes:",
      notesPlaceholder: "Add notes here to help you identify this turret customization. For example, the customer name, email, phone, etc."
    },
    turret: {
      formTitle: "Turret"
    },
    scope: {
      manufacturer: "Manufacturer",
      model: "Model",
      autoFillTitle: "Select Your Scope",
      autoFillFormHint: "Use the following dropdown to select your scope or pick \"Custom Turret\" to create a custom turret decal.",
      formHelper: "These scope details have been auto-filled based on the scope you have selected. Please verify the accuracy of these values against your scope before proceeding.",
      customFormHelper: "We recommend using a caliper to achieve precise scope & turret measurements. Once your details are correct, please click 'next' to proceed.",
      scopeBrand: "Brand",
      scopeBrandPlaceholder: "Select Your Scope Brand",
      scopeModel: "Model",
      scopeModelPlaceholder: "Select Your Scope Model",
      label: "Select Your Scope",
      placeholder: "Select An Option",
      verifyScopeDetails: "Please verify your scope details below & then continue.",
      verifyCustomDetails: "Please select a scope preset above or provide your custom scope & turret details below."
    },
    ammunition: {
      manufacturer: "Manufacturer",
      caliber: "Caliber",
      nameAndWeight: "Name & Weight",
      autoFillTitle: "Select An Ammunition Preset",
      autoFillFormHint: "Use the following dropdown to select an ammunition preset or enter your own ammunition details below.",
      formHint: "The ammunition details above have been auto-filled based on the selected ammunition preset and can no longer be edited.",
      formHelper: "Please note, our simulator only requires the ballistic coefficient, drag model, and weight of your ammunition to accurately compute your bullet drop data.",
      brand: "Brand",
      label: "Select Your Ammunition",
      customAmmunitionPrompt: "-- Don't See Your Ammunition? --",
      customAmmunition: "Select Your Ammunition Manufacturer",
      caliber: "Caliber",
      nameAndWeight: "Name & Weight",
      helpText: "Pre-fill the ammunition details below by selecting your ammunition's manufacturer & model. If you don't see your ammunition, you can enter your own custom values below.",
      placeholder: "Select Your Ammunition",
      manufacturerPlaceholder: "Select Your Ammunition Manufacturer",
      caliberPlaceholder: "Select Your Ammunition Caliber",
      nameAndWeightPlaceholder: "Select Your Ammunition Name & Weight",
      provideAmmunitionDetails: "Can't find your ammunition? No worries, simply enter your custom details below.",
      verifyAmmunitionDetails: "Please verify your ammunition details below & then continue."
    },
    firearm: {
      formHelper: "For best results, we suggest capturing muzzle velocity using a chronograph. Alternatively, muzzle velocity estimates can be found on your ammunition packaging or reloading book."
    },
    environment: {
      formHelper: "The provided values are based on averages for North America. Most users will only need to adjust the altitude & temperature values. To learn more visit our",
      formHelperLink: "Environment F.A.Q."
    },
    dragCoefficient: {
      label: "Ballistic Coefficient",
      helpText: "Ballistic Coefficient (BC) is a measure of how streamlined a bullet is and is a value between 0.1 and 1.2. It can be found on your ammunition packaging or from the manufacturers website.",
      placeholder: "Between 0.1 and 1.2"
    },
    dragModel: {
      label: "Drag Model",
      helpText: "Most modern ammunition fall under the G1 drag model. Please refer to the ballistic data on your ammunition packaging for more information."
    },
    ammunitionWeight: {
      label: "Ammunition Weight",
      helpText: "Weight of the actual bullet you are shooting, measured in grains (GR)."
    },
    altitude: {
      label: "Altitude",
      helpTextImperial: "Average altitude of where you will be hunting/shooting in feet (FT). You turret will remain accurate within 2,000 ft above and below the entered value (i.e. a 4,000 ft window).",
      helpTextMetric: "Average altitude of where you will be hunting/shooting in feet (Meters). You turret will remain accurate within 600 meters above and below the entered value (i.e. a 1,200 meter window).",
      placeholder: "Between 0 - 15,000"
    },
    pressure: {
      label: "Pressure",
      helpText: "Average barometric pressure where you will be hunting/shooting in inches of mercury (inHG). The average barometric pressure for North America is 29.53 inHG.",
      placeholder: "Between 16 - 40"
    },
    temperature: {
      label: "Temperature",
      helpTextImperial: "Average temperature where you will be hunting/shooting in Fahrenheit. Your turret will be accurate 20 degrees above and below the entered value (i.e. 40 degree F window).",
      helpTextMetric: "Average temperature where you will be hunting/shooting in Celsius. Your turret will be accurate 10 degrees above and below the entered value (i.e. 20 degree C window).",
      placeholder: "Between -40 - 140"
    },
    humidity: {
      label: "Humidity",
      helpText: "Average humidity where you will be hunting/shooting as a percentage. Your turret will remain accurate 20% above and below the entered value (i.e. 40% window).",
      placeholder: "Between 0 - 100"
    },
    initialVelocity: {
      label: "Muzzle Velocity",
      helpTextImperial: "Speed of the bullet leaving the muzzle in feet per second (FT/S or FPS).",
      helpTextMetric: "Speed of the bullet leaving the muzzle in meters per second (M/S or MPS).",
      placeholder: "Between 100 - 4400"
    },
    zeroRange: {
      label: "Zero Range",
      helpTextImperial: "The distance at which you've sighted your rifle to hit center without holdover. Usually 100 or 200 yards (YDS).",
      helpTextMetric: "The distance at which you've sighted your rifle to hit center without holdover. Usually 100 or 200 meters (M).",
      placeholder: "Between 0 - 2000"
    },
    isImperial: {
      label: "Turret Unit",
      helpText: "Please select if you would like your turret to be in Yards or Meters.",
      placeholder: "Yards or Meters",
      hintText: "Please note that the form will reset any time you change between yards and meters.",
      imperial: "Yards",
      imperialDescription: "Your turret measurements will be in Yards.",
      metric: "Meters",
      metricDescription: "Your turret measurements will be in Meters.",
      adminModeWarning: "Unit cannot be changed. If customer needs the unit changed, please cancel the order and have them place a new order."
    },
    turretHeight: {
      label: "Turret Height",
      helpTextImperial: "Printable height (i.e. not including knurling) on the face of the turret, measured in inches (IN).",
      helpTextMetric: "Printable height (i.e. not including knurling) on the face of the turret, measured in centimeters (CM).",
      placeholder: "0.1 - 2"
    },
    turretDiameter: {
      label: "Turret Diameter",
      helpTextImperial: "Diameter of the turret from outside edge to outside edge, measured in inches (IN).",
      helpTextMetric: "Diameter of the turret from outside edge to outside edge, measured in centimeters (CM).",
      placeholder: "0.5 - 3"
    },
    sightHeight: {
      label: "Sight Height",
      helpText: "Distance between the center of the barrel and the center of your scope.",
      placeholder: "Between 0.1 and 2"
    },
    clickUnit: {
      label: "Click Unit",
      helpText: "Minute of angle (MOA) or Mils (MIL)."
    },
    clickValue: {
      label: "Click Value",
      helpText: "The number of MOA or MIL per click."
    },
    clicksPerRotation: {
      label: "Clicks Per Rotation",
      helpText: "The number of clicks for one full rotation of your turret.",
      placeholder: "Enter clicks (e.g. 60)"
    },
    direction: {
      label: "Direction",
      helpText: "The direction in which your turret rotates to increase bullet drop compensation.",
      clockwise: "Clockwise",
      counterClockwise: "Counter Clockwise"
    },
    numberOfRevolutions: {
      label: "Number Of Revolutions",
      helpText: "The number of revolutions you would like displayed on your custom turret. Please note, some turret options only support one rotation."
    },
    scopePreviewCard: {
      title: "Selected Scope",
      customTurretNotice: "Use the turret customizer to create your custom turret label.",
      modalClose: "Close",
      notes: "Please Note:",
      helpTextTitle: "How to use the Turret Customizer",
      helpText: "After hitting play, click the <i class=\"fas fa-expand text-primary mx-1\"></i> icon to view the video in full screen.",
    }
  }
}
